import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    credentials: {},
  },
  mutations: {
    setCredentials(state, value) {
      state.credentials = value;
    },
  },
  actions: {
  },
  modules: {
  },
});
